import service from "./service"

const consumerReport = async (preCheckId) => {
    return service(preCheckId)
}

export default consumerReport
